import type { RohsProductComplianceFileView } from '@/shared/hooks/api/rohsComplianceFiles'
import { RohsProductComplianceFileSignOffActions } from '@/v2/components/rohs/RohsProductComplianceFileSignOffActions'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { V2RohsLegislationBriefingStepShell } from './V2RohsLegislationBriefingStepShell'

export function V2RohsProductSignOffStep({
  step,
  index,
  productId,
  productFile,
}: {
  step: RohsBriefingStep
  index: number
  productId: string
  productFile: RohsProductComplianceFileView | null
}) {
  return (
    <V2RohsLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        productFile != null ? (
          <RohsProductComplianceFileSignOffActions
            productId={productId}
            productFile={productFile}
          />
        ) : undefined
      }
    />
  )
}
